import { ClipboardCheck } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "@/api";
import { useAuth } from "@/auth";
import { DateField } from "@/components/DateField";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Paris" });
const COLS = [["calls", "Appels"], ["answered", "Décrochés"], ["reach_rate", "Joignabilité"], ["talk_min", "Min. en ligne"], ["nrp", "NRP"], ["messagerie", "Messagerie"], ["a_rappeler", "À rappeler"], ["pas_interesse", "Pas intéressé"], ["rdv", "Qualifiées"]];
const cell = (r, k) => (k === "reach_rate" ? (r[k] == null ? "—" : `${r[k]} %`) : (r[k] || 0).toLocaleString("fr-FR"));

// Bilan de fin de journée par agent : décrochés = réponse d'une vraie personne (hors NRP / répondeur), issues = boutons de la fiche
const Goal = ({ value, admin, onSave, testid }) => (admin
  ? <input type="number" min="0" max="100" className="ck-goal" defaultValue={value} onBlur={(e) => Number(e.target.value) !== value && onSave(Number(e.target.value))} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} data-testid={testid} />
  : <span data-testid={testid}>{value} %</span>);

export const SessionReport = () => {
  const { user } = useAuth();
  const admin = user?.role === "admin";
  const [day, setDay] = useState(today());
  const [data, setData] = useState(null);
  const saveGoals = async (patch) => {
    const goals = { ...data.goals, ...patch };
    try {
      const { data: g } = await api.put("/settings/session-goals", goals);
      setData((d) => ({ ...d, goals: g, total: { ...d.total, goal: g.reach_rate }, agents: d.agents.map((r) => ({ ...r, goal: g.agents[r.agent] ?? g.reach_rate })) }));
    } catch { /* toast inutile : valeur remise au prochain chargement */ }
  };
  useEffect(() => { setData(null); api.get("/pipeline/session-report", { params: { day } }).then(({ data: d }) => setData(d)).catch(() => setData(false)); }, [day]);
  return (
    <section className="ck-card ck-session" data-testid="session-report">
      <header className="ck-session__head">
        <h2><ClipboardCheck size={18} /> Bilan de session</h2>
        <DateField value={day} clearable={false} onChange={(v) => v && v <= today() && setDay(v)} testid="session-report-day" />
      </header>
      {data === null && <div className="ck-skel" style={{ height: 120 }} data-testid="session-report-loading" />}
      {data === false && <p className="ck-empty">Bilan indisponible pour le moment.</p>}
      {data && (
        <div className="ck-session__scroll">
          <table className="ck-session__table">
            <thead><tr><th>Agent</th>{COLS.map(([k, l]) => <th key={k}>{l}</th>)}<th>Objectif</th></tr></thead>
            <tbody>
              {data.agents.map((r) => <tr key={r.agent} data-testid={`session-row-${r.agent.replace(/\W+/g, "-")}`}><td>{r.agent}</td>{COLS.map(([k]) => <td key={k} className={k === "reach_rate" && r[k] != null ? (r[k] >= r.goal ? "is-goal" : "is-low") : ""}>{cell(r, k)}</td>)}<td><Goal key={`${r.agent}${r.goal}`} value={r.goal} admin={admin} onSave={(v) => saveGoals({ agents: { ...data.goals.agents, [r.agent]: v } })} testid={`session-goal-${r.agent.replace(/\W+/g, "-")}`} /></td></tr>)}
              {!data.agents.length && <tr><td colSpan={COLS.length + 2} className="ck-empty">Aucun appel ce jour-là.</td></tr>}
            </tbody>
            {data.agents.length > 1 && <tfoot><tr data-testid="session-total"><td>Total plateau</td>{COLS.map(([k]) => <td key={k} className={k === "reach_rate" && data.total[k] != null ? (data.total[k] >= data.total.goal ? "is-goal" : "is-low") : ""}>{cell(data.total, k)}</td>)}<td><Goal key={`t${data.total.goal}`} value={data.total.goal} admin={admin} onSave={(v) => saveGoals({ reach_rate: v })} testid="session-goal-total" /></td></tr></tfoot>}
          </table>
        </div>
      )}
    </section>
  );
};
